namespace $.$$ {

	export class $shm_ba_profile_switch extends $.$shm_ba_profile_switch {

		state_key( key: string ) {
			return this.$.$shm_pb.auth_store_key( key )
		}

		state( key: string, next?: string | null ) {
			return this.$.$mol_state_local.value< string >( this.state_key( key ), next )
		}

		login(): string {
			return this.state( 'email' ) || 'Профиль'
		}

		login_url() {
			const location = this.$.$mol_dom_context.location
			if( !location.pathname.includes( '/shm/dashboard/app/-/' ) ) return '/login/'

			const page = location.pathname.endsWith( '/test.html' ) ? 'test.html' : 'index.html'
			return `/shm/dashboard/login/-/${ page }`
		}

		@ $mol_action
		exit() {
			this.$.$shm_ba_pb.user_auth_reset()
			this.$.$mol_dom_context.location.replace( this.login_url() )
		}

	}

}
